const Component = () => import('./AisleAll');

export { Component };
